module.exports = __webpack_public_path__ + "img/vu.f0b65910.svg";